export const shouldCheckTemporaryRegistration = (businessScopeType, acknowledged = false) =>
  businessScopeType === 30 && !acknowledged;

export const resolveTemporaryRegistrationCheck = result => ({
  platformMatched: result?.platformState === true,
  notRegistered: result?.platformState === true && result?.driverState === false
});
